import * as actionTypes from './actionTypes';

import { Nullable } from 'utils/typescript';
import { IChannelDeeplinkResponse, IStartEventData, SocketEvent } from 'types/bigScreen';

export const getBigScreenDeepLinkRequest = () =>
    ({
        type: actionTypes.GET_BIG_SCREEN_DEEP_LINK_REQUEST,
    } as const);

export const getBigScreenDeepLinkSuccess = (payload: IChannelDeeplinkResponse & { bigScreenTokenTTL: number }) =>
    ({
        type: actionTypes.GET_BIG_SCREEN_DEEP_LINK_SUCCESS,
        payload,
    } as const);

export const setSocketMessage = (payload: Nullable<SocketEvent>) =>
    ({
        type: actionTypes.SET_SOCKET_MESSAGE,
        payload,
    } as const);

export const setBigScreenStartData = (payload: IStartEventData) =>
    ({
        type: actionTypes.SET_BIG_SCREEN_START_DATA,
        payload,
    } as const);

export const resetBigScreenStartData = () =>
    ({
        type: actionTypes.RESET_BIG_SCREEN_START_DATA,
    } as const);
